namespace Matrix.Workflow {
    export class ClientFunctionViewColumns {
        static columnsKey = 'Workflow.ClientFunctionInvocationHistory';
    }
}
